import React, { useEffect, useState } from "react";
import { ReleaseDetailsViewModel, releaseAPI } from "../api/releaseAPI";
import { useParams } from "react-router-dom";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Col, Form, Row } from "react-bootstrap";
import { Problem } from "../api/backendApi";
import DateDisplay from "../common/DateDisplay";
import ReleaseFiles from "./ReleaseFiles";

function ReleaseDetailsPage() {
  const [release, setRelease] = useState<ReleaseDetailsViewModel>();
  const releaseName = useParams().name ?? "";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Problem | undefined>(undefined);
  const [fullRelease, setFullRelease] = useState(false);
  const [selectedBaseRelease, setSelectedBaseRelease] = useState("");
  const [pastReleases, setPastReleases] = useState<string[]>([]);

  useEffect(() => {
    async function loadRelease(name: string) {
      setLoading(true);
      const data = await releaseAPI.getReleaseDetails(
        name,
        fullRelease,
        fullRelease ? "" : selectedBaseRelease,
      );

      if (data.ok) {
        setError(undefined);
        setRelease(data.value);
      } else {
        setError(data.problem);
      }

      setLoading(false);
    }
    loadRelease(releaseName);
  }, [fullRelease, selectedBaseRelease, releaseName]);

  useEffect(() => {
    async function loadPastReleases(name: string) {
      const data = await releaseAPI.getPastReleases(name);

      if (data.ok) {
        setError(undefined);
        setPastReleases(data.value);
      } else {
        setError(data.problem);
      }
    }
    loadPastReleases(releaseName);
  }, [releaseName]);

  return (
    <>
      <div className="main-container-title">
        <h1>Details for release {releaseName}</h1>
        <ErrorDisplay error={error} />
        <LoadingDisplay loading={loading} />
        {!loading && !error && release && <p>Name: {release.name}</p>}

        {release && (
          <div>
            <div
              className="row row-cols-auto align-items-center py-2"
              style={{ backgroundColor: "lightgray" }}
            >
              <div className="col">
                <Form.Check
                  id="chk-full-release"
                  label="Show full release"
                  checked={fullRelease}
                  onChange={(e) => setFullRelease(e.target.checked)}
                />
              </div>
              <Form.Label htmlFor="sel-releases" className="col col-form-label">
                Compare with:
              </Form.Label>
              <div className="col">
                <Form.Select
                  id="sel-releases"
                  value={selectedBaseRelease}
                  onChange={(e) => setSelectedBaseRelease(e.target.value)}
                  disabled={fullRelease}
                >
                  {pastReleases.length === 0 ? (
                    <option value="">&lt;previous version&gt;</option>
                  ) : (
                    pastReleases.map((pr, ii) => (
                      <option key={pr} value={pr}>
                        {pr + (ii === 0 ? " <previous version>" : "")}
                      </option>
                    ))
                  )}
                </Form.Select>
              </div>
              <div className="col-4"></div>
              <div className="col">
                <ReleaseFiles releaseName={releaseName} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="main-container-content">
        {!loading && !error && release && (
          <div className="overflow-y-auto overflow-x-hidden">
            <table className="table">
              <thead>
                <tr>
                  <th>Vehicle File</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {release.vehicleFiles.length === 0 ? (
                  <tr>
                    <td colSpan={1}>Nothing...</td>
                  </tr>
                ) : (
                  <>
                    {release.vehicleFiles.map((vf) => (
                      <React.Fragment key={vf.number}>
                        <tr>
                          <td>{vf.number}</td>
                        </tr>
                        <tr>
                          <td colSpan={1}>
                            {vf.dataFiles.map((df) => (
                              <Row key={df.filename} className="ms-3">
                                <Col>{df.filename}</Col>
                                <Col>version: {df.version}</Col>
                                <Col>
                                  {df.deleted ? "deleted by " : "updated by "}
                                  {df.updatedBy} on{" "}
                                  <DateDisplay date={df.updatedDate} />
                                </Col>
                              </Row>
                            ))}
                            {vf.vehicles.map((v) => (
                              <Row key={v.recId} className="ms-3">
                                <Col>RecId: {v.recId}</Col>
                                <Col>{v.description}</Col>
                                <Col>{v.deleted && "deleted"}</Col>
                              </Row>
                            ))}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default ReleaseDetailsPage;
